
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

interface ActivityLog {
  id: string;
  action: string;
  project_name: string | null;
  customer_name: string | null;
  created_at: string;
}

interface RecentActivityProps {
  recentActivity: ActivityLog[];
  isStatsLoading: boolean;
}

const RecentActivity = ({ recentActivity, isStatsLoading }: RecentActivityProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
        <CardDescription>Your latest actions and updates</CardDescription>
      </CardHeader>
      <CardContent>
        {isStatsLoading ? (
          <div className="py-4 text-center text-muted-foreground">Loading activity...</div>
        ) : recentActivity.length === 0 ? (
          <div className="py-4 text-center text-muted-foreground">No recent activity</div>
        ) : (
          <ul className="divide-y divide-border">
            {recentActivity.map((item) => (
              <li key={item.id} className="py-3">
                <div className="flex items-start">
                  <div className="mr-2 mt-0.5">
                    <Clock className="h-4 w-4 text-muted-foreground" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground">
                      {item.action}
                      {item.project_name && <span> - {item.project_name}</span>}
                    </p>
                    {item.customer_name && (
                      <p className="text-sm text-muted-foreground">
                        {item.customer_name}
                      </p>
                    )}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {formatDistanceToNow(new Date(item.created_at), { addSuffix: true })}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};

export default RecentActivity;
